import { render, staticRenderFns } from "./AddHomeWork.vue?vue&type=template&id=5ed38441&scoped=true"
import script from "./AddHomeWork.vue?vue&type=script&lang=js"
export * from "./AddHomeWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed38441",
  null
  
)

export default component.exports